import { GetterTree } from "vuex";
import { AuthState } from "./types";
import { RootState } from "../types";

export const getters: GetterTree<AuthState, RootState> = {
  user: (state) => state.user,
  token: (state) => state.token,
  check: (state) => state.user.id !== null,
};
